import styled from "styled-components";
import { colors, float, layout, media, radii } from "../../../theme";

export const ContactListContainer = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  align-items: stretch;
  gap: clamp(2rem, 4vw, 3rem);
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: clamp(3rem, 6vw, 5rem) ${layout.gutter} clamp(4rem, 8vw, 6rem);

  ${media.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;

  @media screen and (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;

export const LogoPanel = styled.div`
  display: grid;
  place-items: center;
  height: 100%;
  padding: 2rem;
  border: 1px solid rgba(210, 180, 140, 0.45);
  border-radius: ${radii.lg};
  background: radial-gradient(
      circle at 50% 45%,
      rgba(255, 195, 11, 0.22),
      transparent 65%
    ),
    ${colors.backgroundSecondary};
`;

export const ContactLogo = styled.img`
  width: 100%;
  max-width: 22rem;
  height: auto;
  object-fit: contain;
  animation: ${float} 6s ease-in-out infinite;
`;
